import { Controller } from '@hotwired/stimulus';
import { csrfToken } from './functions/util';
import { popover } from './functions/wrapper';

export default class extends Controller {
  static values = {
    schemaKey: String,
    rootKey: String,
    uniqueId: String,
  };

  static targets = ['menu', 'loading'];

  connect() {
    // console.debug('[chat][js] connect', this.identifier);
    this.loaded = false;
    this.loading = false;
  }

  async loadMenu() {
    console.debug('[chat][js][lazy-dropdown] loadMenu called', {
      schemaKey: this.schemaKeyValue,
      rootKey: this.rootKeyValue,
      loaded: this.loaded,
      loading: this.loading,
    });

    // 既に読み込み済みまたは読み込み中の場合は何もしない
    if (this.loaded || this.loading) return;

    this.loading = true;

    try {
      const response = await fetch('/user/api/templates/schema_editor/dropdown_menu_items', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          schema_key: this.schemaKeyValue,
          root_key: this.rootKeyValue,
        }),
      });

      if (!response.ok) throw new Error('Failed to load menu items');

      const html = await response.text();

      // ローディング表示を削除
      if (this.hasLoadingTarget) {
        this.loadingTarget.remove();
      }

      // メニューアイテムを挿入
      this.menuTarget.innerHTML = html;

      // popoverなどの初期化
      popover.applyTo(this.menuTarget);

      this.loaded = true;
    } catch (error) {
      console.error('[lazy-dropdown] Error loading menu:', error);
      this.menuTarget.innerHTML = '<div class="dropdown-item text-danger">読み込みエラー</div>';
    } finally {
      this.loading = false;
    }
  }
}
